<template>
  <div ref="vcv-suggest" class="vcv-suggest" @click="focusInput()">
    <div v-for="item in selectedItems" :key="item.id" class="vcv-suggest__badge">
      <div class="vcv-suggest__badge-text" :title="item.name">{{ item.name }}</div>
      <div class="vcv-suggest__badge-remove" @click="removeBadge(item.id)">
        <span>&times;</span>
      </div>
    </div>

    <input
      ref="suggest-input"
      v-model="suggestText"
      :disabled="isDisabled"
      class="vcv-suggest__input"
    />

    <div
      v-show="isSuggestsShow && suggestText.length > 0"
      class="vcv-suggest__suggests"
      :style="{ top: suggestHeight + 1 + 'px' }"
    >
      <template v-if="suggestArray.length > 0">
        <div
          v-for="item in suggestArray"
          :key="item.id"
          class="vcv-suggest__suggest"
          @click="selectSuggest(item)"
        >
          {{ item.name }}
        </div>
      </template>

      <template v-else>
        <div class="vcv-suggest__nodata">Результатов не найдено</div>
      </template>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';

  export default {
    props: {
      isDisabled: {
        type: Boolean,
        default: false
      },

      // { id: id, name: name }
      suggestArray: {
        type: Array,
        default: () => []
      },

      selectedItems: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        isSuggestsShow: false,
        suggestHeight: 40,
        suggestText: ''
      };
    },

    watch: {
      suggestArray() {
        this.focusInput();
      },

      suggestText(val) {
        if (val.length > 1) {
          this.isSuggestsShow = true;
        }
        this.asyncFind(val);
      }
    },

    mounted() {
      this.setHeight();
    },

    updated() {
      this.setHeight();
    },

    methods: {
      asyncFind: debounce(function (val) {
        this.$emit('suggest', val);
      }, 800),

      async selectSuggest(item) {
        this.isSuggestsShow = false;
        this.$emit('select-suggest', item);
        this.suggestText = '';
        this.focusInput();
      },

      setHeight() {
        this.suggestHeight = this.$refs['vcv-suggest'].clientHeight;
      },

      removeBadge(itemId) {
        this.$emit('remove-badge', itemId);
      },

      focusInput() {
        this.$refs['suggest-input'].focus();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .vcv-suggest {
    position: relative;
    margin-bottom: 10px;
    width: 100%;
    max-width: 100%;
    display: block;
    padding: 0 12px;
    margin: 0;
    border: 1px solid #d2d6e0;
    border-radius: 2px;
    // // font-family: Roboto;
    font-size: 15px;
    color: #233346;
    height: auto !important;
    min-height: 40px;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &__input {
      border: none;
      padding: 0 5px;
    }

    &__suggests {
      padding: 10px 0;
      position: absolute;
      top: 40px;
      left: 0;
      background: #fff;
      z-index: 1000;
      border: 1px solid #d2d6e0;
      border-top: none;
      width: 100%;
      overflow-y: scroll;
      overflow: -moz-scrollbars-vertical;
      max-height: 300px;
      box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.1);
    }

    &__suggest {
      padding: 10px 15px;
      text-overflow: ellipsis;
      max-width: 100%;
      overflow-x: hidden;
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: #eee;
        transition: background 0.3s;
      }
    }

    &__badge {
      display: flex;
      border: 1px solid #d2d6e0;
      border-radius: 5px;
      margin: 3px 10px 3px 0;
      height: 30px;
      align-items: center;
      padding: 4px 26px 4px 12px;
      position: relative;
      overflow: hidden;
    }

    &__badge-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__badge-remove {
      position: absolute;
      right: 0;
      top: 0;
      height: 30px;
      padding: 0 7px;
      font-size: 20px;
      font-weight: 300;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: #eee;
        transition: background 0.3s;
      }

      span {
        margin-top: -3px;
      }
    }

    &__nodata {
      padding: 0 15px;
      color: #aaa;
    }
  }
</style>
